import { Modal } from '@wajeez-web/components/ui';
import { CommonModalProps } from '@wajeez-web/components/modals';
import { useCustomerSelector } from '@wajeez-web/stores/customers';
import { NoData } from '@wajeez-web/components/ui';
import { ReturnTranslatedText } from '@wajeez-web/core/localization';
import { useTranslation } from 'react-i18next';
export const UserSessionsModal = ({
  onClose,
  isOpen,
}: CommonModalProps<unknown>) => {
  const { userMonthlySessions } = useCustomerSelector((s) => s.usersAnalytics);
  const { t } = useTranslation();
  const getMonthName = (monthNumber: any) => {
    const monthNames = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    return monthNames[monthNumber];
  };

  return (
    <Modal
      withScroll={true}
      title="User Sessions"
      onClose={onClose}
      open={isOpen}
    >
      <div className=" text-center ">
        <div className="grid grid-cols-6 py-2 gap-4 ">
          <div className="col-span-2">
            <div className="text-[#727783] text-[14px] font-semibold">
              <ReturnTranslatedText text={'tables.columnTitles.Month'} />
            </div>
          </div>
          <div className="col-span-2">
            <div className="text-[#727783] text-[14px] font-semibold">
              <ReturnTranslatedText
                text={'tables.columnTitles.Number of Sessions'}
              />
            </div>
          </div>
          <div className="col-span-2">
            <div className="text-[#727783] text-[14px] font-semibold">
              <ReturnTranslatedText
                text={'tables.columnTitles.Total Duration'}
              />
            </div>
          </div>
        </div>
        {userMonthlySessions.length === 0 && (
          <div className="mt-4">
            {' '}
            <NoData />
          </div>
        )}
        {userMonthlySessions.map((session, index: number) => {
          return (
            <div className="grid grid-cols-6 py-2 gap-4 " key={index}>
              <div className="col-span-2">
                <div className="text-[#727783] text-[14px] font-normal">
                  {getMonthName(session.month)} {session.year}
                </div>
              </div>
              <div className="col-span-2">
                <div className="text-[#727783] text-[14px] font-normal">
                  {session.numberOfSessions}
                </div>
              </div>
              <div className="col-span-2">
                <div
                  className={`text-[#727783] text-[14px] font-normal ${
                    session?.totalDurationInMinutes &&
                    session?.totalDurationInMinutes > 120
                      ? 'bg-red-100 border-red-400 border-2'
                      : ''
                  }`}
                >
                  {session?.totalDurationInMinutes &&
                    Math.round(session?.totalDurationInMinutes / 60)}{' '}
                  <ReturnTranslatedText text="tables.columnValues.hour" /> -{' '}
                  {session.totalDurationInMinutes?.toFixed(0)}{' '}
                  <ReturnTranslatedText text="tables.columnValues.minute" />
                </div>
              </div>
            </div>
          );
        })}{' '}
      </div>
    </Modal>
  );
};

export default UserSessionsModal;
